var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActicsLandingPageLayout',[_c('ActicsMenuBoxes',{staticClass:"grow-1 px-3 mt-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }